import { ApiManager } from './api/ApiManager';
import { FView } from './FView';

export class AuthManager {
    public CheckAuth() : Promise<boolean> {
        return new Promise((onCompleted, onFailed) => {
            let apiManager: ApiManager = FView.Get().apiManager;
            apiManager.MakeRequest("auth_check")
                .then(r => onCompleted(r.ok))
                .catch(ex => onFailed(ex));
        });
    }

    public CheckCredentials(form: HTMLFormElement) : Promise<void> {
        return new Promise((onCompleted, onFailed) => {
            let apiManager: ApiManager = FView.Get().apiManager;
            apiManager.SubmitForm("auth_login", form)
                .then(r => {
                    if (r.ok) {
                        onCompleted();
                    } else {
                        onFailed(r.errorMessage);
                    }
                })
                .catch(ex => onFailed(ex))
        });
    }

    public Logout() : Promise<void> {
        return new Promise((onCompleted, onFailed) => {
            let apiManager: ApiManager = FView.Get().apiManager;
            apiManager.MakeRequest("auth_logout")
                .then(_ => onCompleted())
                .catch(ex => onFailed(ex));
        });
    }
}
